<script>
    import { getIbeHost } from "shared/Utilities/fetchUtilities";

    export default {
        methods: {
            getImgUrl() {
                return getIbeHost() + "/Content/responsive/images/error_i.svg";
            }
        }
    }
</script>

<template>
    <div class="error">
        <div class="error-img">
            <img :src="getImgUrl()" alt="">
        </div>
        <div class="error-message" role="alert">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="less">
    @import "~less-variables";
    @invalid-border-style: 1px solid @ibe-text--red !important;

    .error {
        display: flex;
        align-items: flex-start;
        margin-top: 5px;
        color: @ibe-text--red;
        
        .error-img {
            margin-right: .75em;

            img {
                width: 1em;
                height: 1em;
                vertical-align: top;
            }
        }

        .error-message {
            font-size: 12px;
            line-height: 1.25em;
            font-weight: 600;
            width: 100%;

            a {
                color: @ibe-text--red;
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }

    [aria-invalid=true],
    .invalid {
        &:not(.checkbox-container) {
            input, textarea, select {
                border: @invalid-border-style;
            }
        }
    }

    .checkbox-container[aria-invalid=true],
    .checkbox-container.invalid {
        border: @invalid-border-style;
    }

    input, textarea, select {
        &[aria-invalid=true],
        &.invalid {
            border: @invalid-border-style;
        }
    }
</style>